import React from 'react';

interface ConfirmOverlayProps {
  visible: boolean;
  title: string;
  description: string;
  okText: string;
  cancelText: string;
  onOk: () => void | Promise<void>;
  onCancel: () => void;
}

const ConfirmOverlay: React.FC<ConfirmOverlayProps> = ({
  visible,
  title,
  description,
  okText,
  cancelText,
  onOk,
  onCancel
}) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 20000
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          padding: 24,
          minWidth: 320,
          maxWidth: '90%',
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: 12, color: '#000000' }}>{title}</h3>
        <p style={{ marginBottom: 24, color: '#000000D9' }}>{description}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            type="button"
            style={{
              padding: '6px 16px',
              borderRadius: 4,
              border: '1px solid #d9d9d9',
              background: '#fff',
              cursor: 'pointer',
              color: '#000000D9'
            }}
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            style={{
              padding: '6px 16px',
              borderRadius: 4,
              border: 'none',
              background: '#ff4d4f',
              color: '#fff',
              cursor: 'pointer'
            }}
            onClick={onOk}
          >
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmOverlay;
